const localStorageKey = {
  locale: 'locale',
  fullLocale: 'fullLocale',
  calendarNotification: 'calendarNotification',
}

export default localStorageKey
